import { AxiosResponse } from "axios";
import { fetchAPI } from "../../../../config/axios";
import { TAction, TDispatch } from "../../../types";
import { KRIAction, KRIActionType, KRIModel } from "./types";

export const KRIRegisterDefault: KRIModel = {
  prioritasiRisikoDepartemen: {
    data: [],
    total: 0,
    can_approval: false,
  },
  agregasiRisiko: {
    data: [],
    total: 0,
  },
  detailAgregasi: {},
  prioritasiRisikoAgregat: {
    data: {
      id_user: "",
      penilai: "",
      prioritasAgregat: [],
    },
    total: 0,
  },
  penetapanRisikoUtama: {
    data: [],
    total: 0,
  },
  detailAmbangKRI: {},
  registerIRU: {
    data: [],
    total: 0,
  },
  detailRegisterIRU: {
    data: {} as any,
  }
};

export const KRIRegisterReducer = (
  state: KRIModel = KRIRegisterDefault,
  action: KRIAction
): KRIModel => {
  switch (action.type) {
    case KRIActionType.GetPrioritasiRisikoDepartemen:
      return { ...state, prioritasiRisikoDepartemen: action.data };
    case KRIActionType.GetAgregasiRisiko:
      return { ...state, agregasiRisiko: action.data };
    case KRIActionType.GetDetailAgregasiRisiko:
      return { ...state, detailAgregasi: action.data };
    case KRIActionType.GetPrioritasiRisikoAgregat:
      return { ...state, prioritasiRisikoAgregat: action.data };
    case KRIActionType.GetPenetapanRisikoUtama:
      return { ...state, penetapanRisikoUtama: action.data };
    case KRIActionType.GetAmbangKRI:
      return { ...state, detailAmbangKRI: action.data };
    case KRIActionType.GetRegisterIRU:
      return { ...state, registerIRU: action.data };
    case KRIActionType.GetDetailRegisterIRU:
      return { ...state, detailRegisterIRU: action.data };
    default:
      return state;
  }
};

export const KRIRegisterCommand = {
  GetPrioritasiRisikoDepartemen: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-kri-prioritasi-risiko-dapartmens",
          { params }
        );
         
        dispatch({
          type: KRIActionType.GetPrioritasiRisikoDepartemen,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
            can_approval: response.data.data.can_approval
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePrioritasiRisikoDepartemen: (
    body?: any
  ): TAction<KRIAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-prioritasi-risiko-dapartmen",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  ApprovalPrioritisasiRisikoDepartemen: (
      body?: any
    ): TAction<KRIAction, AxiosResponse<any, any>> => {
      return async (dispatch: TDispatch<KRIAction>) => {
        try {
          const url = body.type === "approve" ? "/tj-kri-prioritasi-risiko-dapartmen/submit" : "/tj-kri-prioritasi-risiko-dapartmen/reject";
          const response = await fetchAPI().post(url, body.body);
          return response;
        } catch (error) {
          throw error;
        }
      };
    },
  EditPrioritasiRisikoDepartemen: (
    body?: any
  ): TAction<KRIAction, AxiosResponse<any, any>> => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-kri-prioritasi-risiko-dapartmen",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  GetAgregasiRisiko: (params: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().get("/tj-kri-agregasi-risikos", {
          params,
        });
        dispatch({
          type: KRIActionType.GetAgregasiRisiko,
          data: {
            data: response.data.data?.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  GetDetailAgregasiRisiko: (params: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().get("/tj-kri-agregasi-risiko", {
          params,
        });
         
        dispatch({
          type: KRIActionType.GetDetailAgregasiRisiko,
          data: response.data.data,
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateAgregasiRisiko: (body: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().post("/tj-kri-agregasi-risiko", body);
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateAgregasiRisiko: (body: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-kri-agregasi-risiko",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteAgregasiRisiko: (params: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().delete("/tj-kri-agregasi-risiko", {
          params,
        });
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  GetPrioritasiRisikoAgregat: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-kri-prioritasi-agregasi-risikos",
          { params }
        );
        dispatch({
          type: KRIActionType.GetPrioritasiRisikoAgregat,
          data: {
            data: response.data.data,
            total: response.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePrioritasiRisikoAgregat: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-prioritasi-agregasi-risiko",
          body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  GetPenetapanRisikoUtama: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-kri-penetapan-risiko-utamas",
          {
            params,
          }
        );
        dispatch({
          type: KRIActionType.GetPenetapanRisikoUtama,
          data: {
            data: response.data?.data?.data,
            total: response.data?.data?.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreatePenetapanRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-penetapan-risiko-utama/set-key-risk",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  UncreatePenetapanRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-penetapan-risiko-utama/unset-key-risk",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  ApprovalPenetapanRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const url = body.type ==="approve" ? "/tj-kri-register/submit" : "/tj-kri-register/reject"
        const response = await fetchAPI().post(url,
            body.body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  SendEmailPenetapanRisikoUtama: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-send-email",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  CreateDetailMainRisk: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-register/detail-main-risk",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  GetAmbangKRI: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/setting?key=ambang_kri",
          {
            params,
          }
        );
        dispatch({
          type: KRIActionType.GetAmbangKRI,
          data: response.data?.data,
        });
      } catch (error) {
        throw error;
      }
    };
  },
  GetRegisterIRU: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-kri-registers",
          {
            params,
          }
        );
        dispatch({
          type: KRIActionType.GetRegisterIRU,
          data: {
            data: response.data?.data?.data,
            total: response.data?.data?.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  ApprovalRegisterIRU: (body: any) => {
    return async (dispatch: any) => {
      try {
        const url = body.type ==="approve" ? "/tj-kri-penetapan-risiko-utama/submit" : "/tj-kri-penetapan-risiko-utama/reject"
        const response = await fetchAPI().post(url,
            body.body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  SendEmailRegisterIRU: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-send-email",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  GetDetailRegisterIRU: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-kri-register",
          {
            params,
          }
        );
        dispatch({
          type: KRIActionType.GetRegisterIRU,
          data: {
            data: response.data?.data?.data,
            total: response.data?.data?.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateRegisterIRU: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-kri-register",
            body
        );
        return response
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateRegisterIRU: (body: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-kri-register",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteRegisterIRU: (params: any) => {
    return async (dispatch: TDispatch<KRIAction>) => {
      try {
        const response = await fetchAPI().delete("/tj-kri-register", {
          params,
        });
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
